<template>
  <article class="message" :class="type" v-show="isActive">
    <div class="message-body">
      <div class="columns is-mobile">
        <div class="column">
          <slot></slot>
        </div>
        <div class="column is-narrow">
          <a class="delete" @click="close()"></a>
        </div>
      </div>
    </div>
  </article>
</template>

<script>
export default {
  name: "Message",
  props: {
    type: {
      type: String
    },
    active: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isActive: this.active
    };
  },
  methods: {
    close() {
      this.isActive = false;
    },
    open() {
      this.isActive = true;
    }
  }
};
</script>
